/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetGachaRequest } from '../../models/get-gacha-request';
import { GetGachaResponse } from '../../models/get-gacha-response';

export interface GachaServiceGetGacha$Params {
      body: GetGachaRequest
}

export function gachaServiceGetGacha(http: HttpClient, rootUrl: string, params: GachaServiceGetGacha$Params, context?: HttpContext): Observable<StrictHttpResponse<GetGachaResponse>> {
  const rb = new RequestBuilder(rootUrl, gachaServiceGetGacha.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetGachaResponse>;
    })
  );
}

gachaServiceGetGacha.PATH = '/api/v3/gateway/gacha';
